// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NGsg","questions":"styles_questions__3Rant","footer":"styles_footer__27ucY"};